import SegmentUtils from 'utils/segment';

/* eslint-disable camelcase */
export default function trackMidFunnelLanding({pageType, city, airportCode}) {
    const properties = {
        page_type: pageType,
        city,
        ...(airportCode && {airport_code: airportCode}),
    };

    SegmentUtils.page({
        name: 'Mid Funnel Landing',
        properties,
    });
}
